var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.20662 4.6875C7.64569 4.6875 6.375 5.95762 6.375 7.51912C6.375 9.08062 7.64512 10.3502 9.20662 10.3502C10.7681 10.3502 12.0377 9.08062 12.0377 7.51912C12.0377 5.95762 10.7676 4.6875 9.20662 4.6875ZM9.20662 9.1875C8.28637 9.1875 7.53769 8.43881 7.53769 7.51912C7.53769 6.59944 8.28637 5.85019 9.20662 5.85019C10.1269 5.85019 10.8756 6.59887 10.8756 7.51912C10.8756 8.43937 10.1269 9.1875 9.20662 9.1875Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3891 13.59C13.6036 12.1748 15.0492 9.97313 15.0374 7.5195C15.0374 4.30369 12.4218 1.6875 9.2065 1.6875C5.99125 1.6875 3.37507 4.30144 3.37507 7.515C3.36382 9.97144 4.80888 12.1742 6.02332 13.5894C7.40538 15.2004 8.80994 16.2 8.869 16.2416C9.06757 16.3834 9.346 16.3834 9.544 16.2416C9.60307 16.1994 11.0127 15.1943 12.3891 13.59ZM9.31282 14.9513L9.2065 15.0379L9.10019 14.9513C8.50282 14.4664 7.35363 13.4584 6.36307 12.1528C5.14469 10.5474 4.531 8.98819 4.53775 7.51837C4.53775 4.94438 6.63194 2.85019 9.2065 2.85019C11.7799 2.85019 13.8747 4.94606 13.8758 7.52231C13.8826 8.991 13.2683 10.5491 12.0499 12.1539C11.0594 13.4601 9.91019 14.4669 9.31282 14.9513Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationGrey);
export default __webpack_public_path__ + "static/media/icon-location-grey.4668f3352d293041d7bd5f716103ee02.svg";
export { ForwardRef as ReactComponent };